// extracted by mini-css-extract-plugin
export default {"header__item":"HeaderItemBurger_header__item__Qrs2g","header__link":"HeaderItemBurger_header__link__V+ifI","header__menuBurger":"HeaderItemBurger_header__menuBurger__WPPqH"};